/**
 * Register. GSAP
 */
gsap.registerPlugin(ScrollTrigger);
gsap.config({ trialWarn: false });
ScrollTrigger.config({ 
  ignoreMobileResize: true,
  limitCallbacks: true // Only runs callbacks when necessary to save CPU
});

// window.addEventListener("resize", () => {
//   ScrollTrigger.refresh();
// });

/********************************************************
 * HEADER WRAPPER STYLE (WHEN SLIDESHOW IS FIRST SECTION)
 ********************************************************/
// (function() {
//   const initInsetHeader = () => {
//     const triggerSection = document.querySelector('[data-header-inset-trigger]');
//     const headerWrapper = document.querySelector('.header__wrapper');

//     if (!triggerSection || !headerWrapper) return;

//     const observerOptions = {
//       root: null,
//       threshold: 0,
//       rootMargin: `-${headerWrapper.offsetHeight || 80}px 0px 0px 0px` 
//     };

//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           headerWrapper.style.setProperty('margin-inline', '0.625rem', 'important');
//         } else {
//           headerWrapper.style.setProperty('margin-inline', '0', 'important');
//         }
//       });
//     }, observerOptions);

//     observer.observe(triggerSection);
//   };

//   if (document.readyState === 'complete') {
//     initInsetHeader();
//   } else {
//     window.addEventListener('load', initInsetHeader);
//   }

//   document.addEventListener('shopify:section:load', (e) => {
//     if (e.target.querySelector('[data-header-inset-trigger]')) {
//       initInsetHeader();
//     }
//   });
// })();

/********************************
 * bl_bullet-point-banner.liquid
 ********************************/
if (!customElements.get('bl-bullet-point')) {
  class BlBulletPoint extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.bl-bp__wrapper');
      this.dots = this.querySelectorAll('.bl-bp__dot');
      this.currentIndex = 0;
      this.timer = null;
      this.scrollTimeout = null;
      this.itemsPerPage = 1;
      this.totalPages = 0;
      this.intervalDuration = 8000;
    }

    connectedCallback() {
      this.updateLayout();
      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const index = parseInt(dot.getAttribute('data-index'));
          this.goToPage(index, true); 
        });
      });

      this.wrapper.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          const newPageIndex = Math.round(this.wrapper.scrollLeft / this.wrapper.offsetWidth);
          if (newPageIndex !== this.currentIndex && newPageIndex < this.totalPages) {
            this.goToPage(newPageIndex, true); 
          }
        }, 50);
      }, { passive: true });

      window.addEventListener('resize', () => this.updateLayout());
      
      requestAnimationFrame(() => this.goToPage(0, false));
    }

    updateLayout() {
      const prevItemsPerPage = this.itemsPerPage;
      this.itemsPerPage = 1;
      this.totalPages = Math.ceil(this.dots.length / this.itemsPerPage);

      this.dots.forEach((dot, index) => {
        dot.style.display = index < this.totalPages ? 'block' : 'none';
      });

      if (prevItemsPerPage !== this.itemsPerPage) {
        this.goToPage(0, true);
      }
    }

    goToPage(index, isManual = false) {
      this.stopTimer();

      if (index >= this.totalPages) index = 0;
      this.currentIndex = index;

      const targetScroll = this.wrapper.offsetWidth * index;
      if (Math.abs(this.wrapper.scrollLeft - targetScroll) > 5) {
        this.wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
      }

      this.dots.forEach(dot => dot.classList.remove('is-active'));
      if (this.dots[this.currentIndex]) {
        void this.dots[this.currentIndex].offsetWidth; 
        this.dots[this.currentIndex].classList.add('is-active');
      }

      this.startTimer();
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.totalPages;
        this.goToPage(nextIndex, false);
      }, this.intervalDuration);
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    disconnectedCallback() {
      this.stopTimer();
    }
  }

  customElements.define('bl-bullet-point', BlBulletPoint);
}

/********************************
 * bl_image-packery.liquid
 ********************************/
if (!customElements.get('bl-background-looping')) {
  class BlBackgroundLooping extends HTMLElement {
    connectedCallback() {
      this.textPath = this.querySelector('.loopTextPath');
      this.path = this.querySelector('path');
      if (!this.textPath || !this.path) return;

      this.offset = 0;
      this.phraseWidthPercent = 0;
      this.animationFrame = null;
      this.resizeObserver = new ResizeObserver(() => this.updateDimensions());
      this.resizeObserver.observe(this);

      this.animate();
    }

    updateDimensions() {
      const totalTextLength = this.textPath.getComputedTextLength();
      const pathLength = this.path.getTotalLength();

      if (totalTextLength > 0) {
        this.phraseWidthPercent = ((totalTextLength / 15) / pathLength) * 100;
      }
    }

    animate() {
      this.offset -= 0.05; 

      if (this.phraseWidthPercent > 0 && Math.abs(this.offset) >= this.phraseWidthPercent) {
        this.offset = 0;
      }

      this.textPath.setAttribute('startOffset', this.offset + '%');
      this.animationFrame = requestAnimationFrame(() => this.animate());
    }

    disconnectedCallback() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }
  customElements.define('bl-background-looping', BlBackgroundLooping);
}

if (!customElements.get('bl-ip-wrapper')) {
  class BlIpWrapper extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth < 700) {
        const items = this.querySelectorAll('.bl-ip__image');
        if (items.length >= 2) {
          requestAnimationFrame(() => {
            const secondItem = items[1];
            const scrollLeft = secondItem.offsetLeft + (secondItem.offsetWidth / 2) - (this.offsetWidth / 2);
            this.scrollTo({ left: scrollLeft, behavior: 'auto' });
          });
        }
      }
    }
  }
  customElements.define('bl-ip-wrapper', BlIpWrapper);
}

/********************************
 * bl_team-card.liquid
 ********************************/
if (!customElements.get('bl-team-card')) {
  customElements.define('bl-team-card', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.openPopup.bind(this));
    }

    connectedCallback() {
      this._reveal_fn();
    }

    _reveal_fn() {
      const tl = gsap.timeline({
        paused: true
      });

      tl.from(this.querySelector(".bl-tc__name_position p"), {
        opacity: 0,
        y: 20,
        duration: 0.4,
        ease: "power2.inOut"
      }, "<")
      
      ScrollTrigger.create({
        trigger: this.closest(".shopify-section"),
        start: "top 60%",
        onEnter: (self) => {
          if (self.progress < 1 && self.direction === 1) {
            tl.play();
            self.kill();
          }
        },
        onEnterBack: (self) => {
          tl.play();
          self.kill(); 
        }
      });
    }
    openPopup() {
      if (window.innerWidth > 999) return;

      const popupId = this.getAttribute('data-card-popup');
      const popup = document.getElementById(popupId);
      
      if (popup) {
        popup.setAttribute('open', '');
        document.body.style.overflow = 'hidden'; 
        if (!popup.dataset.closeBound) {
          const closePopup = () => {
            popup.removeAttribute('open');
            document.body.style.overflow = '';
          };
          
          const overlay = popup.querySelector('.bl-tc__card-popup_overlay');
          if (overlay) overlay.addEventListener('click', closePopup);

          const closeBtn = popup.querySelector('.bl-tc__close-btn');
          if (closeBtn) closeBtn.addEventListener('click', closePopup);

          popup.dataset.closeBound = "true";
        }
      }
    }
  });
}

if (!customElements.get('team-card-popup')) {
  customElements.define('team-card-popup', class extends HTMLElement {
    connectedCallback() {
      this.injectCloseButton();
      
      this.addEventListener('click', (event) => {
        const isOverlay = event.target.classList.contains('bl-tc__card-popup_overlay');
        const isCloseBtn = event.target.closest('.bl-tc__close-btn');
        
        if (isOverlay || isCloseBtn) {
          this.close();
        }
      });
    }

    injectCloseButton() {
      const contentContainer = this.querySelector('div:not(.bl-tc__card-popup_overlay)');
      if (contentContainer && !contentContainer.querySelector('.bl-tc__close-btn')) {
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'bl-tc__close-btn';
        closeBtn.innerHTML = '&times;'; 
        closeBtn.setAttribute('aria-label', 'Close');
        contentContainer.prepend(closeBtn);
      }
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  });
}

/**************************************
 * bl_central-floating-elements.liquid
 **************************************/
if (!customElements.get('floating-element')) {
  class FloatingElement extends HTMLElement {
    constructor() {
      super();
      this.isAnimated = false;
      this._finalRect = { x: 0, y: 0, w: 0, h: 0 };
      this._handleResize = () => this.calculatePosition();
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._handleResize);
    }

    init() {
      if (window.innerWidth < 700) return;
      this.style.opacity = '0';
      this.style.visibility = 'hidden';
      this.style.position = 'absolute';
      this.style.whiteSpace = 'nowrap';
      this.style.zIndex = '2';

      const ro = new ResizeObserver(() => {
        if (this.parentElement.offsetHeight > 50) {
          this.initIntersection();
          ro.disconnect();
        }
      });
      ro.observe(this.parentElement);
    }

    initIntersection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimated) {
            this.isAnimated = true;
            this.calculatePosition(true); 
          }
        });
      }, { threshold: 0.1 });
      observer.observe(this.parentElement);
    }

    resetStyles() {
      const props = ['position','left','top','transform','opacity','visibility','transition','white-space','z-index'];
      props.forEach(p => this.style.removeProperty(p));
      this.classList.remove('is-floating');
      this.isAnimated = false; 
    }

    calculatePosition(triggerAnimation = false) {
      if (window.innerWidth < 700) {
        this.resetStyles();
        return;
      }

      const parent = this.parentElement;
      const allItems = Array.from(parent.querySelectorAll('floating-element'));
      const index = allItems.indexOf(this);
      const total = allItems.length;

      const pW = parent.offsetWidth;
      const pH = parent.offsetHeight;
      const centerX = pW / 2;
      const centerY = pH / 2;

      const myW = this.offsetWidth;
      const myH = this.offsetHeight;

      const half = Math.ceil(total / 2);
      const isTop = index < half;

      let angle;
      const sweep = Math.PI * 0.75; 
      if (isTop) {
        const step = sweep / (half > 1 ? half - 1 : 1);
        angle = -Math.PI + ((Math.PI - sweep) / 2) + (step * index);
      } else {
        const bottomIndex = index - half;
        const bottomTotal = total - half;
        const step = sweep / (bottomTotal > 1 ? bottomTotal - 1 : 1);
        angle = ((Math.PI - sweep) / 2) + (step * bottomIndex);
      }

      const rx = pW * 0.36;
      const ry = pH * 0.38;

      let tx = centerX + Math.cos(angle) * rx - (myW / 2);
      let ty = centerY + Math.sin(angle) * ry - (myH / 2);

      tx = Math.max(20, Math.min(tx, pW - myW - 20));
      ty = Math.max(20, Math.min(ty, pH - myH - 20));

      this._finalRect = { x: tx, y: ty, w: myW, h: myH };

      for (let i = 0; i < index; i++) {
        const other = allItems[i]._finalRect;
        if (!other || other.w === 0) continue;
        const padding = 20;
        if (this._finalRect.x < other.x + other.w + padding && this._finalRect.x + this._finalRect.w + padding > other.x && this._finalRect.y < other.y + other.h + padding && this._finalRect.y + this._finalRect.h + padding > other.y) {
          this._finalRect.y += isTop ? -45 : 45;
          this._finalRect.y = Math.max(20, Math.min(this._finalRect.y, pH - myH - 20));
        }
      }

      this.style.position = 'absolute';
      this.style.left = `${this._finalRect.x}px`;
      this.style.top = `${this._finalRect.y}px`;

      if (triggerAnimation) this.animateIn(index);
    }

    animateIn(index) {
      this.style.visibility = 'visible';
      this.style.opacity = '0';
      this.style.transform = 'translate3d(0, 20px, 0)';
      
      const duration = 1100;
      const delay = index * 120;

      setTimeout(() => {
        this.style.transition = `opacity ${duration}ms ease, transform ${duration}ms cubic-bezier(0.16, 1, 0.3, 1), left 0.3s ease-out, top 0.3s ease-out`;
        this.style.opacity = '1';
        this.style.transform = 'translate3d(0, 0, 0)';

        setTimeout(() => {
          this.style.transition = 'opacity 0.6s ease, left 0.3s ease-out, top 0.3s ease-out';
          this.style.transform = 'translate3d(0, 0, 0)';
          
          this.offsetHeight; 

          requestAnimationFrame(() => {
            this.classList.add('is-floating');
            this.style.setProperty('--float-dur', `${5 + Math.random() * 3}s`);
            this.style.setProperty('--float-del', `${Math.random() * -5}s`);
            this.style.setProperty('--float-offset', `${-10 - Math.random() * 10}px`);
          });
        }, duration);

      }, delay);
    }
  }

  customElements.define('floating-element', FloatingElement);
}

/********************************
 * bl_flex-card.liquid
 ********************************/
if (!customElements.get('bl-flex-card')) {
  class BlFlexCard extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-flex_card__card');
      this.isMobileScrollInit = false;
      // "Slower Animation" section setting: on mobile the page stops at the cards
      // and one scroll gesture expands the next card (see the stepper below).
      this.slowAnimation = this.hasAttribute('slow-animation');

      // Bind methods
      this.handleResize = this.handleResize.bind(this);
      this.scrollHandler = this.scrollHandler.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.onStepScroll = this.onStepScroll.bind(this);
      this.onStepTouchStart = this.onStepTouchStart.bind(this);
      this.onStepTouchMove = this.onStepTouchMove.bind(this);
      this.onStepWheel = this.onStepWheel.bind(this);
      this.onStepKey = this.onStepKey.bind(this);

      // Desktop Hover Listeners
      this.cards.forEach(card => {
        card.addEventListener('mouseenter', () => this.handleMouseEnter(card));
        card.addEventListener('mouseleave', this.handleMouseLeave);
      });
      
      window.addEventListener('resize', this.handleResize);
      this.handleResize(); // Init on load
    }
    
    handleResize() {
      if (window.innerWidth <= 999) {
        this.initMobileScroll();
        this.measureContents();
      } else {
        this.destroyMobileScroll();
      }
    }

    /* ==============================
       DESKTOP: Same Row Sibling Logic
    ============================== */
    handleMouseEnter(hoveredCard) {
      if (window.innerWidth < 1000 || hoveredCard.classList.contains('bl-flex_card__full_width_card')) return;
      
      const hoveredRect = hoveredCard.getBoundingClientRect();
      
      this.cards.forEach(card => {
        // If it's not the hovered card, and it's not a full width card
        if (card !== hoveredCard && !card.classList.contains('bl-flex_card__full_width_card')) {
          const cardRect = card.getBoundingClientRect();
          // Check if the top coordinates align (meaning they are in the exact same row)
          // 10px buffer handles sub-pixel rendering discrepancies
          if (Math.abs(cardRect.top - hoveredRect.top) < 10) {
            card.classList.add('is-sibling-hovered');
          }
        }
      });
    }

    handleMouseLeave() {
      this.cards.forEach(card => card.classList.remove('is-sibling-hovered'));
    }
    
    /* ==============================
       MOBILE: Center Scroll Tracker
    ============================== */
    // Feeds --bl-fc-content-h so the max-height transition covers the real
    // content height (scrollHeight ignores the collapsed max-height).
    measureContents() {
      this.cards.forEach((card) => {
        const content = card.querySelector('.bl-flex_card__content');
        if (content) card.style.setProperty('--bl-fc-content-h', content.scrollHeight + 'px');
      });
    }

    initMobileScroll() {
      if (this.isMobileScrollInit || this.cards.length === 0) return;
      this.isMobileScrollInit = true;
      this.measureContents();

      if (this.useStepper()) {
        this.initStepper();
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.scrollHandler();
    }

    // The theme editor and reduced-motion users keep the plain tracker: no scroll-jacking there.
    useStepper() {
      if (!this.slowAnimation) return false;
      if (window.Shopify && window.Shopify.designMode) return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onScroll() {
      if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = window.requestAnimationFrame(this.scrollHandler);
    }

    scrollHandler() {
      if (window.innerWidth >= 1000) return;
      
      const viewportCenter = window.innerHeight / 2;
      let closestCard = null;
      let minDistance = Infinity;

      this.cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + (rect.height / 2);
        const distance = Math.abs(viewportCenter - cardCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      if (closestCard && !closestCard.classList.contains('is-active')) {
        this.cards.forEach(c => c.classList.remove('is-active'));
        closestCard.classList.add('is-active');
      }
    }

    destroyMobileScroll() {
      if (this.isMobileScrollInit) {
        window.removeEventListener('scroll', this.onScroll);
        if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
        this.destroyStepper();
        this.isMobileScrollInit = false;
      }
      this.cards.forEach(card => card.classList.remove('is-active'));
    }

    /* ==============================
       MOBILE: Gesture Stepper ("Slower Animation")
       Modelled on bl_scrolling-module-v2: as the cards approach their resting
       line the page glides into place and locks; one gesture (swipe / wheel
       tick / arrow key) expands the next or previous card; the gesture past
       either end releases the page. Crossing back over the line re-locks on
       the card that was left active. Nothing is expanded until the page stops.

       The page does not scroll while locked: the wrapper is positioned so the
       stack fits with its tallest card expanded, so cards grow and shrink in
       place. Only a stack taller than the screen gets a one-directional nudge
       per step. That keeps the hide-on-scroll header still (it shows on any
       upward scroll) and avoids per-frame scroll work.
    ============================== */
    initStepper() {
      this.step = 0;
      this.locked = false;
      this.armed = true;
      this.busy = false;
      this.prevTop = null;
      this.touchY = null;
      this.touchDone = false;

      // Landing below the cards (reload, anchor): rest on the last card so
      // scrolling back up re-locks there.
      if (this.getBoundingClientRect().top < this.restingLine()) {
        this.step = this.cards.length - 1;
        this.renderStep();
      }

      window.addEventListener('scroll', this.onStepScroll, { passive: true });
    }

    destroyStepper() {
      if (this.locked) this.unlockStepper();
      window.removeEventListener('scroll', this.onStepScroll);
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      this.settleRaf = null;
    }

    stepCard() {
      return this.cards[this.step];
    }

    // Height a card gains when active: its content plus the 80px header/content gap.
    expansionOf(card) {
      const content = card.querySelector('.bl-flex_card__content');
      return (content ? content.scrollHeight : 0) + 80;
    }

    // Stack height with every card collapsed plus the tallest single expansion:
    // the most room any step will need.
    projectedStackHeight() {
      let height = 0;
      let maxExpansion = 0;
      this.cards.forEach((card) => {
        const expansion = this.expansionOf(card);
        height += card.offsetHeight - (card.classList.contains('is-active') ? expansion : 0);
        maxExpansion = Math.max(maxExpansion, expansion);
      });
      const gap = parseFloat(getComputedStyle(this).rowGap) || 0;
      return height + gap * (this.cards.length - 1) + maxExpansion;
    }

    stackFits() {
      return this.projectedStackHeight() <= window.innerHeight - 40;
    }

    // Resting position of the wrapper's top: centred when the projected stack
    // fits, else 20px from the top. `withHeader` also clears a visible header
    // (upward entry, where the theme has just shown it).
    restingLine(withHeader = false) {
      let minTop = 20;
      if (withHeader) {
        const header = document.querySelector('store-header');
        if (header) minTop = Math.max(minTop, header.getBoundingClientRect().bottom + 20);
      }
      return Math.max(minTop, (window.innerHeight - this.projectedStackHeight()) / 2);
    }

    renderStep() {
      this.cards.forEach((card, i) => card.classList.toggle('is-active', i === this.step));
    }

    stepTo(dir) {
      if (this.busy) return;
      const last = this.cards.length - 1;
      if (dir > 0) {
        if (this.step < last) { this.step++; this.slideStep(1); } else this.unlockStepper();
      } else {
        if (this.step > 0) { this.step--; this.slideStep(-1); } else this.unlockStepper();
      }
    }

    // One step: swap the active card and hold input for the CSS transition.
    slideStep(dir) {
      const STEP_MS = 650;
      this.busy = true;
      this.renderStep();
      if (this.stackFits()) {
        setTimeout(() => { this.busy = false; }, STEP_MS);
      } else {
        this.followStep(dir, STEP_MS, () => { this.busy = false; });
      }
    }

    // Tall stacks only: nudge the page in the step's direction so the active
    // card stays on screen while it expands. Never reverses, so the header
    // does not flip. Lenis runs while the position changes (stopped, it puts
    // overflow:hidden on <html> and clamps a scroll in flight) and is stopped
    // again once done.
    followStep(dir, duration, done) {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      if (window.lenis) window.lenis.start();

      const t0 = performance.now();
      const frame = (now) => {
        const rect = this.stepCard().getBoundingClientRect();
        let need = 0;
        if (dir > 0) {
          // Bring the bottom up into view, but never push the top above the margin.
          need = Math.min(Math.max(0, rect.bottom + 20 - window.innerHeight), Math.max(0, rect.top - 20));
        } else {
          need = Math.min(0, rect.top - 20);
        }
        if (Math.abs(need) > 0.5) window.scrollBy(0, need * 0.25);

        if (now - t0 < duration) {
          this.settleRaf = window.requestAnimationFrame(frame);
        } else {
          this.settleRaf = null;
          if (window.lenis && this.locked) window.lenis.stop();
          done();
        }
      };
      this.settleRaf = window.requestAnimationFrame(frame);
    }

    // Eased scroll to an absolute position (manual rAF, see followStep for why
    // not behavior:'smooth' with Lenis).
    snapTo(target, done) {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      const start = window.scrollY;
      const dist = target - start;
      if (Math.abs(dist) < 2) { done(); return; }
      const t0 = performance.now();
      const D = 400;
      const frame = (now) => {
        const p = Math.min((now - t0) / D, 1);
        window.scrollTo(0, start + dist * (1 - Math.pow(1 - p, 3)));
        if (p < 1) this.settleRaf = window.requestAnimationFrame(frame);
        else { this.settleRaf = null; done(); }
      };
      this.settleRaf = window.requestAnimationFrame(frame);
    }

    engageStepper(dir) {
      this.locked = true;
      this.armed = false;
      this.busy = true;
      this.addStepBlockers();
      this.renderStep();

      const line = this.restingLine(dir < 0);
      const target = window.scrollY + this.getBoundingClientRect().top - line;
      this.snapTo(target, () => {
        if (window.lenis) window.lenis.stop();
        // Entering downward the header must stay hidden. The snap normally moves
        // down (the band catches the cards before the line), but a fast fling
        // can overshoot and snap back up, which the theme reads as scrolling up.
        if (dir > 0) setTimeout(() => this.hideStoreHeader(), 100);
        this.busy = false;
      });
    }

    unlockStepper() {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      this.settleRaf = null;
      this.removeStepBlockers();
      if (window.lenis) window.lenis.start();
      this.locked = false;
      this.armed = false;
      this.busy = false;
      this.prevTop = this.getBoundingClientRect().top;
    }

    hideStoreHeader() {
      const header = document.querySelector('store-header');
      if (header && header.hasAttribute('hide-on-scroll') && typeof header.hide === 'function') header.hide();
    }

    onStepScroll() {
      if (this.locked) return;

      // Engage a band ahead of the line so the glide finishes in the direction
      // the visitor was already scrolling.
      const BAND = 120;
      const top = this.getBoundingClientRect().top;
      const line = this.restingLine();

      if (this.prevTop === null) { this.prevTop = top; return; }

      // Right after a release the cards sit on the line; wait until they have
      // moved clearly away before a crossing can lock again.
      if (!this.armed) {
        if (Math.abs(top - line) > BAND + 40) this.armed = true;
        this.prevTop = top;
        return;
      }

      const enteredScrollingDown = this.prevTop > line + BAND && top <= line + BAND;
      const enteredScrollingUp = this.prevTop < line - BAND && top >= line - BAND;
      this.prevTop = top;

      const last = this.cards.length - 1;
      if (enteredScrollingDown && this.step < last) this.engageStepper(1);
      else if (enteredScrollingUp && this.step > 0) this.engageStepper(-1);
    }

    onStepTouchStart(e) {
      this.touchY = e.touches[0].clientY;
      this.touchDone = false;
    }

    onStepTouchMove(e) {
      e.preventDefault();
      if (this.touchDone || this.touchY === null) return;
      const dy = e.touches[0].clientY - this.touchY;
      if (Math.abs(dy) > 30) {
        this.touchDone = true;
        this.stepTo(dy < 0 ? 1 : -1);
      }
    }

    onStepWheel(e) {
      e.preventDefault();
      if (Math.abs(e.deltaY) < 4) return;
      this.stepTo(e.deltaY > 0 ? 1 : -1);
    }

    onStepKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') { e.preventDefault(); this.stepTo(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); this.stepTo(-1); }
    }

    addStepBlockers() {
      window.addEventListener('touchstart', this.onStepTouchStart, { passive: true });
      window.addEventListener('touchmove', this.onStepTouchMove, { passive: false });
      window.addEventListener('wheel', this.onStepWheel, { passive: false });
      window.addEventListener('keydown', this.onStepKey, true);
    }

    removeStepBlockers() {
      window.removeEventListener('touchstart', this.onStepTouchStart);
      window.removeEventListener('touchmove', this.onStepTouchMove);
      window.removeEventListener('wheel', this.onStepWheel);
      window.removeEventListener('keydown', this.onStepKey, true);
    }
    
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroyMobileScroll();
    }
  }
  
  customElements.define('bl-flex-card', BlFlexCard);
}

/********************************
 * bl_number-counter.liquid
 ********************************/
if (!customElements.get('bl-number-cards')) {
  customElements.define('bl-number-cards', class extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-number_card');
      this.counters = this.querySelectorAll('bl-number-counter');
    }

    connectedCallback() {
      this.counters.forEach((counter, index) => {
        const originalText = counter.textContent.trim();
        const targetVal = parseFloat(originalText.replace(/,/g, ''));
        
        if (!isNaN(targetVal)) {
          counter.dataset.target = targetVal;
          counter.dataset.hasComma = originalText.includes(',');
          counter.dataset.decimals = originalText.includes('.') ? originalText.split('.')[1].length : 0;
          counter.textContent = '0';
        }
        if(this.cards[index]) {
          this.cards[index].style.transitionDelay = `${index * 0.15}s`;
        }
      });

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-revealed');
            this.startCounting();
            observer.unobserve(this);
          }
        });
      }, { 
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px"
      });

      this.observer.observe(this);
    }

    startCounting() {
      const duration = 2500;

      this.counters.forEach((counter, index) => {
        const target = parseFloat(counter.dataset.target);
        if (isNaN(target)) return;
        
        const decimals = parseInt(counter.dataset.decimals);
        const hasComma = counter.dataset.hasComma === 'true';

        const formatNumber = (num) => {
          if (hasComma) {
            return num.toLocaleString('en-US', {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals
            });
          }
          return num.toFixed(decimals);
        };

        setTimeout(() => {
          let startTimestamp = null;

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            
            const currentVal = easeProgress * target;
            counter.textContent = formatNumber(currentVal);

            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              counter.textContent = formatNumber(target);
            }
          };

          window.requestAnimationFrame(step);
        }, index * 150);
      });
    }
  });
}

/********************************************************
 * bl_parallax-banner.liquid
 ********************************************************/
if (!customElements.get('bl-parallax-banner')) {
  class BlParallaxBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.closest('.bl-scroll-track');
      this.slides = Array.from(this.querySelectorAll('.bl-parallax_banner__image_wrapper'));
      
      if (this.slides.length < 2 || !this.track) return;

      this.slides.forEach((slide, index) => {
        slide.style.zIndex = index;
      });

      this.windowWidth = window.innerWidth;

      this.updateDimensions = () => {
        const trackRect = this.track.getBoundingClientRect();
        this.trackAbsoluteTop = trackRect.top + window.scrollY;
        this.trackHeight = trackRect.height;
        this.maxScroll = this.trackHeight - window.innerHeight;
      };

      this.updateDimensions();
      this.onResize = () => {
        if (window.innerWidth !== this.windowWidth) {
          this.windowWidth = window.innerWidth;
          this.updateDimensions();
        }
      };
      window.addEventListener('resize', this.onResize, { passive: true });

      this.lastScrollY = -1;
      
      this.updateFrame = () => {
        if (this.lastScrollY === window.scrollY) {
          this.rafId = requestAnimationFrame(this.updateFrame);
          return;
        }
        this.lastScrollY = window.scrollY;

        const currentTrackTop = this.trackAbsoluteTop - window.scrollY;
        let progress = -currentTrackTop / this.maxScroll;
        progress = Math.max(0, Math.min(1, progress));

        const totalSlides = this.slides.length;
        const progressPerSlide = 1 / (totalSlides - 1);
        const dwellRatio = 0.35; 

        this.slides.forEach((slide, index) => {
          const slideStart = (index - 1) * progressPerSlide;
          const slideEnd = index * progressPerSlide;
          const segmentLength = slideEnd - slideStart;
          const slideActiveStart = slideStart + (segmentLength * dwellRatio);
          
          const nextSlideStart = index * progressPerSlide;
          const nextSlideEnd = (index + 1) * progressPerSlide;
          const nextSegmentLength = nextSlideEnd - nextSlideStart;
          const nextActiveStart = nextSlideStart + (nextSegmentLength * dwellRatio);

          if (index > 0) {
            if (progress <= slideActiveStart) {
              slide.style.transform = `translate3d(0, 100%, 0)`;
            } else if (progress >= slideEnd) {
              slide.style.transform = `translate3d(0, 0%, 0)`;
            } else {
              const slideProgress = (progress - slideActiveStart) / (slideEnd - slideActiveStart);
              const yPos = 100 - (slideProgress * 100);
              slide.style.transform = `translate3d(0, ${yPos}%, 0)`;
            }
          }
          if (index < totalSlides - 1) {
            if (progress >= nextActiveStart && progress <= nextSlideEnd) {
              const fadeProgress = (progress - nextActiveStart) / (nextSlideEnd - nextActiveStart);
              slide.style.opacity = 1 - (fadeProgress * 0.6);
            } else if (progress > nextSlideEnd) {
              slide.style.opacity = 0.4;
            } else {
              slide.style.opacity = 1;
            }
          }

          const slideMidPoint = slideActiveStart + ((slideEnd - slideActiveStart) * 0.5);
          const nextMidPoint = nextActiveStart + ((nextSlideEnd - nextActiveStart) * 0.5);
          
          const isRevealed = index === 0 ? true : progress >= slideMidPoint;
          const isCoveredByNext = index < totalSlides - 1 && progress >= nextMidPoint;
          
          if (isRevealed && !isCoveredByNext) {
            if (!slide.classList.contains('is-active')) slide.classList.add('is-active');
          } else {
            if (slide.classList.contains('is-active')) slide.classList.remove('is-active');
          }
        });

        clearTimeout(this.snapTimeout);
        this.snapTimeout = setTimeout(() => {
          if (progress > 0 && progress < 1) {
            const exactSlide = progress / progressPerSlide;
            const nearestSlide = Math.round(exactSlide); 
            
            if (Math.abs(exactSlide - nearestSlide) > 0.02) {
              const targetProgress = nearestSlide * progressPerSlide;
              const targetScrollTop = this.trackAbsoluteTop + (targetProgress * this.maxScroll);
              
              if (window.lenis) {
                window.lenis.scrollTo(targetScrollTop, { lerp: 0.1 });
              } else {
                window.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
              }
            }
          }
        }, 350);

        this.rafId = requestAnimationFrame(this.updateFrame);
      };

      this.rafId = requestAnimationFrame(this.updateFrame);
    }
    
    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      clearTimeout(this.snapTimeout);
      window.removeEventListener('resize', this.onResize);
    }
  }
  customElements.define('bl-parallax-banner', BlParallaxBanner);
}

/********************************************************
 * bl-multi-image_with_usp.liquid
 ********************************************************/
class AutoLoopImages extends HTMLElement {
  constructor() {
    super();
    this._imageList = this.querySelector("multiple-images-with-text-image-list");
    this._timer = null;
    this._speed = 4000;
  }

  connectedCallback() {
    // Only run if there is more than 1 image
    if (!this._imageList || this._imageList.children.length <= 1) return;

    // Use IntersectionObserver so it only slides when user sees it
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._startAutoplay();
        } else {
          this._stopAutoplay();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(this);

    // Pause animation when user hovers over the USPs/Content
    this.addEventListener('mouseenter', () => this._stopAutoplay());
    this.addEventListener('mouseleave', () => this._startAutoplay());
  }

  _startAutoplay() {
    this._stopAutoplay();
    this._timer = setInterval(() => {
      // We call the 'next' method that exists on the original MultipleImagesWithTextImageList component
      if (this._imageList && typeof this._imageList.next === 'function') {
        this._imageList.next();
      }
    }, this._speed);
  }

  _stopAutoplay() {
    if (this._timer) clearInterval(this._timer);
  }

  disconnectedCallback() {
    this._stopAutoplay();
  }
}

// Define the custom element
if (!window.customElements.get("auto-loop-images")) {
  window.customElements.define("auto-loop-images", AutoLoopImages);
}

/********************************
 * Cart welcome offer (auto-add the Welcome Kit gift)
 ********************************/
// Which purchase options of the target products earn the gift comes from Theme settings →
// Welcome Kit (BL) (window.themeVariables.settings.welcomeKitMode: 'subscription' | 'onetime' |
// 'both'). The product page and Product Tabs V2 panels read the same setting, so what is shown
// and what is added always agree. Read lazily so a late-defined themeVariables still works.
(function () {
  const TARGET_IDS = ['15973231329361', '15973238734929'];
  // Historical name kept on purpose: gift lines already sitting in customer carts carry this
  // key, and isGiftItem() relies on it to reconcile them. It applies to one-time gifts too.
  const PROP_KEY = '_Subscription_Welcome_Offer';
  let _busy = false;

  // Anything other than an explicit 'both' / 'onetime' (missing setting, unknown value, script
  // loaded before js-variables) resolves to subscription-only, so the gift is never added for a
  // one-time purchase by accident.
  function kitMode() {
    const mode = window.themeVariables?.settings?.welcomeKitMode;
    return mode === 'both' || mode === 'onetime' ? mode : 'subscription';
  }

  // Added based on which specific variant of the target product is in the cart
  const VARIANT_WELCOME_MAP = {
    '60029879451729': [{ variantId: '60071500054609' }],
    '60029879484497': [{ variantId: '60071500054609' }],
    '60029879582801': [{ variantId: '60071500054609' }],
    '60029879615569': [{ variantId: '60071500054609' }],
    '60029888069713': [{ variantId: '60071500054609' }],
    '60029888102481': [{ variantId: '60071500054609' }],
    '60029888135249': [{ variantId: '60071500054609' }],
    '60029888168017': [{ variantId: '60071500054609' }]
  };

  // ---- CSS ----
  const _style = document.createElement('style');
  _style.textContent =
    'cart-drawer,.shopify-section--main-cart{position:relative}' +
    'cart-drawer.bl-cart-loading,.shopify-section--main-cart.bl-cart-loading{pointer-events:none}' +
    '.bl-cart-overlay{position:absolute;inset:0;z-index:9999;background:rgb(var(--background) / .78);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px}' +
    '.bl-cart-overlay__spinner{width:32px;height:32px;border:3px solid rgb(var(--text-color) / .15);border-top-color:rgb(var(--text-color));border-radius:50%;animation:bl-spin .7s linear infinite}' +
    '@keyframes bl-spin{to{transform:rotate(360deg)}}' +
    '.bl-cart-overlay__text{font-size:13px;color:rgb(var(--text-color));margin:0}' +
    'line-item[data-bl-gift] line-item-quantity{display:none!important}';
  document.head.appendChild(_style);

  // ---- Overlay ----
  // Cover both the cart drawer (popover/drawer cart) and the standalone cart page
  function getCartContainers() {
    return Array.from(document.querySelectorAll('cart-drawer, .shopify-section--main-cart'));
  }

  function isOverlayNode(node) {
    return node && node.nodeType === 1 && node.classList && node.classList.contains('bl-cart-overlay');
  }

  // Hold count — while > 0 the MutationObserver will not auto-hide the overlay.
  // Used by the welcome-offer flow so the overlay survives the multiple fetches
  // and the final cart re-render.
  let _overlayHold = 0;

  // text: optional message (the Free gift (BL) engine passes its setting); default "Updating cart…".
  function showCartLoading(text) {
    getCartContainers().forEach(function (target) {
      if (target.querySelector(':scope > .bl-cart-overlay')) return;
      target.classList.add('bl-cart-loading');
      const o = document.createElement('div');
      o.className = 'bl-cart-overlay';
      o.innerHTML = '<div class="bl-cart-overlay__spinner"></div><p class="bl-cart-overlay__text"></p>';
      o.querySelector('.bl-cart-overlay__text').textContent = typeof text === 'string' && text ? text : 'Updating cart…';
      target.appendChild(o);
    });
  }

  // Skipped while another flow still holds the overlay (the Free gift (BL) engine reconciling after this module has
  // finished), so the shopper never sees a half-updated cart with the overlay already gone.
  function hideCartLoading() {
    if (_overlayHold > 0) return;
    getCartContainers().forEach(function (target) {
      target.classList.remove('bl-cart-loading');
      target.querySelector(':scope > .bl-cart-overlay')?.remove();
    });
  }

  // Wait for the next real (non-overlay) content mutation on a cart container,
  // so the welcome-offer flow can keep the overlay visible until the cart
  // drawer/cart page has actually re-rendered with the final state.
  function awaitCartContentChange(timeoutMs) {
    if (timeoutMs == null) timeoutMs = 5000;
    return new Promise(function (resolve) {
      const containers = getCartContainers();
      if (!containers.length) return resolve();
      let settled = false;
      const observers = [];
      const finish = function () {
        if (settled) return;
        settled = true;
        observers.forEach(function (o) { o.disconnect(); });
        resolve();
      };
      containers.forEach(function (c) {
        const obs = new MutationObserver(function (mutations) {
          const real = mutations.some(function (m) {
            const added = Array.from(m.addedNodes).some(function (n) { return !isOverlayNode(n); });
            const removed = Array.from(m.removedNodes).some(function (n) { return !isOverlayNode(n); });
            return added || removed;
          });
          if (real) finish();
        });
        obs.observe(c, { childList: true, subtree: true });
        observers.push(obs);
      });
      setTimeout(finish, timeoutMs);
    });
  }

  // ---- MutationObserver — re-hide overlay after cart container re-renders ----
  // Filter out mutations that only involve our own overlay node, otherwise
  // appending the overlay would trigger an immediate hide. Also skip while the
  // welcome-offer flow has the overlay explicitly held.
  function setupCartObservers() {
    getCartContainers().forEach(function (container) {
      const observer = new MutationObserver(function (mutations) {
        if (_overlayHold > 0) return;
        const hasRealChange = mutations.some(function (m) {
          const added = Array.from(m.addedNodes).some(function (n) { return !isOverlayNode(n); });
          const removed = Array.from(m.removedNodes).some(function (n) { return !isOverlayNode(n); });
          return added || removed;
        });
        if (hasRealChange) hideCartLoading();
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  // Show overlay on every theme-driven cart update (manual qty change, remove
  // link, product form add). Both code paths in theme.js dispatch this event
  // synchronously right before the fetch starts.
  function bindCartUpdateTriggers() {
    document.addEventListener('cart:prepare-bundled-sections', function () { showCartLoading(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupCartObservers();
      bindCartUpdateTriggers();
    });
  } else {
    setupCartObservers();
    bindCartUpdateTriggers();
  }

  // ---- Helpers ----
  // A subscription line is any line bought on a selling plan. Recharge subscriptions are
  // Shopify selling plans and this store sells nothing else on a plan, so the presence of the
  // allocation is the reliable signal. Do not match on the plan *name*: Recharge plan names
  // (e.g. "Deliver every 4 weeks") need not contain the word "subscription", and a name match
  // would silently stop the gift from ever being added.
  function isSubscriptionItem(item) {
    return !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  // A one-time purchase posts no selling plan at all.
  function isOnetimeItem(item) {
    return !isSubscriptionItem(item);
  }

  // Does this line item earn the Welcome Kit under the configured eligibility?
  //  - 'subscription' (default): target product lines on a subscription selling plan only.
  //    One-time lines never earn the gift, and an existing gift line is removed by handleCart()
  //    once no subscription line of a target product remains in the cart.
  //  - 'both': every line of a target product, whatever its selling plan.
  //  - 'onetime': target product lines with no selling plan.
  function isEligibleItem(item) {
    if (!TARGET_IDS.includes(String(item.product_id))) return false;
    const mode = kitMode();
    if (mode === 'both') return true;
    if (mode === 'onetime') return isOnetimeItem(item);
    return isSubscriptionItem(item);
  }

  function checkCartItems(cart) {
    cart.items.forEach(function (item) {
      if (!TARGET_IDS.includes(String(item.product_id))) return;
    });
  }

  // A gift item carries the hidden property. We check for property *presence*
  // (not value), since each gift add uses a unique property value to guarantee
  // Shopify never merges it with a manual add.
  function isGiftItem(item) {
    return !!(item.properties && item.properties[PROP_KEY]);
  }

  // ---- Main handler ----
  // Reconcile gift items against current eligible items every cart change.
  // The needed quantity for each gift variant is summed across eligible
  // lines (multiplied by each line's quantity). Existing gift lines that are
  // orphaned (no eligible line left) or have a stale quantity are removed;
  // missing gifts are added.
  async function handleCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    checkCartItems(cart);

    if (_busy) return;

    // Build the needed gift map from current eligible items.
    const neededMap = {};
    cart.items.forEach(function (item) {
      if (!isEligibleItem(item)) return;
      const mapped = VARIANT_WELCOME_MAP[String(item.variant_id)];
      if (!mapped) return;
      mapped.forEach(function (w) {
        const qty = (w.quantity || 1) * (item.quantity || 1);
        neededMap[w.variantId] = (neededMap[w.variantId] || 0) + qty;
      });
    });

    // Group existing gift lines by variant_id (there can be multiple lines per
    // variant because each add uses a unique property tag).
    const existingGifts = {};
    cart.items.forEach(function (item) {
      if (!isGiftItem(item)) return;
      const v = String(item.variant_id);
      (existingGifts[v] = existingGifts[v] || []).push(item);
    });

    const changes = [];
    const toAdd = [];

    // For each existing gift variant, decide whether to keep, remove, or rebuild.
    Object.keys(existingGifts).forEach(function (variantId) {
      const items = existingGifts[variantId];
      const needed = neededMap[variantId] || 0;
      const totalExisting = items.reduce(function (s, i) { return s + i.quantity; }, 0);

      if (items.length === 1 && needed === totalExisting) return;

      // Otherwise zero out all existing lines and re-add a single consolidated
      // line if still needed. Simpler than trying to patch quantities in place,
      // and avoids leaving multiple split lines after qty changes.
      items.forEach(function (i) { changes.push({ key: i.key, quantity: 0 }); });
      if (needed > 0) toAdd.push({ variantId: variantId, quantity: needed });
    });

    // Variants needed that aren't in cart yet.
    Object.keys(neededMap).forEach(function (variantId) {
      if (existingGifts[variantId]) return;
      if (neededMap[variantId] > 0) {
        toAdd.push({ variantId: variantId, quantity: neededMap[variantId] });
      }
    });

    if (!changes.length && !toAdd.length) return;

    _busy = true;
    _overlayHold++;
    showCartLoading();
    try {
      for (const change of changes) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: change.key, quantity: change.quantity })
        });
      }

      if (toAdd.length) {
        // Unique value per add prevents Shopify from merging the gift line item
        // with any customer-added copy of the same variant. The 'YES' prefix
        // keeps it readable in the Shopify admin.
        const items = toAdd.map(function (entry) {
          const uniqueTag = 'YES-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
          return { id: Number(entry.variantId), quantity: entry.quantity, properties: { [PROP_KEY]: uniqueTag } };
        });

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      await awaitCartContentChange();
    } finally {
      _busy = false;
      _overlayHold = Math.max(0, _overlayHold - 1);
      hideCartLoading();
    }
  }

  // Shared with the Free gift (BL) engine below: one overlay for both, so they never stack two.
  window.blCartOverlay = {
    show: showCartLoading,
    hide: hideCartLoading,
    awaitChange: awaitCartContentChange,
    hold: function () { _overlayHold++; },
    release: function () { _overlayHold = Math.max(0, _overlayHold - 1); }
  };

  document.addEventListener('cart:change', function (event) {
    handleCart(event.detail && event.detail.cart);
  });

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(handleCart);
})();

/********************************
 * Free gift (BL) – gift variants per trigger unit (Travel Pack)
 ********************************/
// Rules come from Theme settings → Free Gift (BL), rendered to window.blFreeGift by snippets/bl-free-gift-config.liquid
// (one rule = trigger product, gift product, "Size mapping" text, eligible purchase options, sold-out handling,
// schedule). On every cart change, and once on page load, the engine:
//
//  1. sums, for every trigger line in the cart, the gift variants its mapping line calls for, times the line quantity
//     (two trigger packs earn the gifts twice; a size shared by two trigger lines adds up);
//  2. compares that with the gift product's lines in the cart;
//  3. posts the absolute quantities to cart/update.js in ONE request (adds, raises, lowers or removes), then asks the
//     theme to re-render the cart (cart:refresh) under the shared "Updating cart" overlay of the welcome offer module.
//
// Gift lines carry NO line item property: a gift is any line of a rule's gift product, which is also what the Shopify
// discount (Buy X get Y) targets to make it free. Hence the gift product cannot be bought on its own while a rule is
// on (extra units are trimmed back to what the rules call for). Pricing is never touched here: the Shopify discount
// zeroes the line and the cart shows the theme's default (discounted) price.
//
// Master switch off, rule off, or rule outside its schedule: that gift product is simply left alone (no trimming), so
// a leftover gift becomes an ordinary line the shopper can remove.
//
// Safety nets: after every pass the engine re-reads cart.js and reconciles again (so a change that landed while it was
// busy, or one made by the welcome offer module on the same event, is caught), and it re-checks on any cart:refresh it
// did not send itself. On the Liquid side, snippets/bl-free-gift-line.liquid styles a gift line as a gift only while
// its trigger is in the cart, so in the moment between the trigger's removal and the gifts' removal (or if this script
// ever fails) the gift lines render as ordinary, removable lines.
//
// Console helper: blFreeGift.debug() prints the parsed rules and what the engine would do with the current cart.
(function () {
  const cfg = window.blFreeGift;
  if (!cfg || !Array.isArray(cfg.rules)) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const overlay = window.blCartOverlay || {
    show: function () {}, hide: function () {}, hold: function () {}, release: function () {},
    awaitChange: function () { return Promise.resolve(); }
  };

  function warn() {
    if (window.console) console.warn.apply(console, ['[bl-free-gift]'].concat(Array.prototype.slice.call(arguments)));
  }

  // "Tape / NB", "tape/nb" and "Tape  /  NB" compare equal.
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/\s*\/\s*/g, ' / ').replace(/\s+/g, ' ').trim();
  }

  // "Size mapping" text → { triggerVariantId: [{ variant, qty }] }. A line reads "trigger title => gift title, gift
  // title x2"; "*" on the left matches every trigger variant; "#" starts a comment line. Unknown titles are skipped
  // with a console warning, so a typo in the settings never adds a wrong variant.
  function parseMapping(rule) {
    const byTrigger = {};
    if (!rule.main || !rule.gift) return byTrigger;
    const giftByTitle = {};
    rule.gift.variants.forEach(function (v) { giftByTitle[norm(v.title)] = v; });
    const mainByTitle = {};
    rule.main.variants.forEach(function (v) { (mainByTitle[norm(v.title)] = mainByTitle[norm(v.title)] || []).push(v); });

    String(rule.mapping || '').split(/\r?\n/).forEach(function (raw) {
      const line = raw.trim();
      if (!line || line.charAt(0) === '#') return;
      const parts = line.split('=>');
      if (parts.length !== 2) { warn('rule ' + rule.index + ': cannot read "' + line + '" (expected "trigger => gift, gift x2")'); return; }
      const left = norm(parts[0]);
      const triggers = left === '*' ? rule.main.variants : (mainByTitle[left] || []);
      if (!triggers.length) { warn('rule ' + rule.index + ': no variant "' + parts[0].trim() + '" on ' + rule.main.title); return; }
      const gifts = [];
      parts[1].split(',').forEach(function (chunk) {
        const item = chunk.trim();
        if (!item) return;
        const m = /^(.*?)(?:\s+[x×]\s*(\d+))?$/i.exec(item);
        const variant = giftByTitle[norm(m[1])];
        if (!variant) { warn('rule ' + rule.index + ': no variant "' + m[1].trim() + '" on ' + rule.gift.title); return; }
        const qty = m[2] ? parseInt(m[2], 10) : 1;
        if (qty > 0) gifts.push({ variant: variant, qty: qty });
      });
      triggers.forEach(function (t) { byTrigger[String(t.id)] = (byTrigger[String(t.id)] || []).concat(gifts); });
    });
    return byTrigger;
  }

  const rules = cfg.rules.map(function (rule) { return Object.assign({}, rule, { map: parseMapping(rule) }); });
  const activeRules = cfg.enabled ? rules.filter(function (r) { return r.active && r.main && r.gift; }) : [];
  // Gift products the engine owns: every variant of these is set to exactly what the rules call for.
  const ownedProducts = {};
  activeRules.forEach(function (r) { ownedProducts[String(r.gift.id)] = true; });

  // Same rule as the welcome offer: a line on any selling plan is a subscription line.
  function isSubscription(item) { return !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan); }
  function eligible(item, mode) {
    if (mode === 'subscription') return isSubscription(item);
    if (mode === 'onetime') return !isSubscription(item);
    return true;
  }

  // What the cart should hold vs what it holds, as absolute quantities per gift variant.
  function plan(cart) {
    const needed = {};
    const current = {};
    cart.items.forEach(function (item) {
      if (ownedProducts[String(item.product_id)]) {
        current[String(item.variant_id)] = (current[String(item.variant_id)] || 0) + item.quantity;
      }
      activeRules.forEach(function (rule) {
        if (String(item.product_id) !== String(rule.main.id) || !eligible(item, rule.eligibility)) return;
        let gifts = rule.map[String(item.variant_id)] || [];
        if (rule.soldOut === 'skip_all') {
          if (gifts.some(function (g) { return !g.variant.available; })) gifts = [];
        } else {
          gifts = gifts.filter(function (g) { return g.variant.available; });
        }
        gifts.forEach(function (g) {
          needed[String(g.variant.id)] = (needed[String(g.variant.id)] || 0) + g.qty * item.quantity;
        });
      });
    });
    const updates = {};
    let changes = 0;
    Object.keys(Object.assign({}, needed, current)).forEach(function (variantId) {
      if ((needed[variantId] || 0) !== (current[variantId] || 0)) {
        updates[variantId] = needed[variantId] || 0;
        changes++;
      }
    });
    return { needed: needed, current: current, updates: changes ? updates : null, signature: JSON.stringify(needed) };
  }

  async function postUpdates(updates) {
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    });
    const json = await response.json().catch(function () { return null; });
    return { ok: response.ok, json: json };
  }

  let busy = false;
  let rerun = false;
  let reloading = false;
  let selfRefresh = false;
  // Needed-signature of the last pass that could not be completed (sold out since render, API error): the same
  // impossible update is not retried on every cart change, only once the trigger lines change.
  let stuck = null;

  async function reconcile(cart) {
    if (!activeRules.length || reloading || !cart || !Array.isArray(cart.items)) return;
    if (busy) { rerun = true; return; }
    const p = plan(cart);
    if (!p.updates || stuck === p.signature) return;

    busy = true;
    overlay.hold();
    // The gift message only when gifts are being added; removals and trims keep the overlay's default text.
    const adding = Object.keys(p.updates).some(function (id) { return p.updates[id] > (p.current[id] || 0); });
    overlay.show(adding ? cfg.loadingText : undefined);
    try {
      let result = await postUpdates(p.updates);
      if (!result.ok) {
        // One refused item (typically out of stock since the page was rendered) fails the whole batch: retry one
        // variant at a time so the rest still lands.
        warn('cart/update.js refused the batch, retrying one by one:', result.json && (result.json.description || result.json.message));
        for (const variantId of Object.keys(p.updates)) {
          const single = {};
          single[variantId] = p.updates[variantId];
          const r = await postUpdates(single);
          if (!r.ok) warn('variant ' + variantId + ' could not be set to ' + single[variantId] + ':', r.json && (r.json.description || r.json.message));
        }
        result = { ok: true, json: await (await fetch(root + 'cart.js')).json() };
      }
      const after = result.json && Array.isArray(result.json.items) ? plan(result.json) : null;
      stuck = after && after.updates ? p.signature : null;
      if (stuck) warn('cart could not be brought in line with the rules; waiting for the next change. Still missing:', after.updates);

      if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
        // The cart page re-renders by reload, like the theme's own quantity changes do. Keep the overlay up.
        reloading = true;
        window.location.reload();
        return;
      }
      selfRefresh = true;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      selfRefresh = false;
      await overlay.awaitChange();
    } catch (error) {
      stuck = p.signature;
      warn('update failed:', error);
    } finally {
      busy = false;
      if (!reloading) {
        overlay.release();
        overlay.hide();
        // Verification pass: re-read the cart and reconcile again. Catches a cart change that arrived while busy
        // (rerun) and anything another script changed meanwhile (the welcome offer module runs on the same event).
        // A cart that is in line costs one cart.js read and nothing else.
        rerun = false;
        checkServerCart();
      }
    }
  }

  function checkServerCart() {
    if (busy || reloading) { rerun = true; return; }
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(reconcile).catch(function () {});
  }

  document.addEventListener('cart:change', function (event) {
    reconcile(event.detail && event.detail.cart);
  });

  // Another script re-rendered the cart from the server (e.g. the welcome offer module after removing its kit):
  // make sure the gifts still match. Our own refresh is skipped.
  document.addEventListener('cart:refresh', function () {
    if (selfRefresh || !activeRules.length) return;
    checkServerCart();
  });

  // Page restored from the back/forward cache: the cart may have changed on another page.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && activeRules.length) checkServerCart();
  });

  if (activeRules.length) checkServerCart();

  cfg.debug = async function () {
    const cart = await (await fetch(root + 'cart.js')).json();
    console.log('[bl-free-gift] master switch:', !!cfg.enabled, '| owned gift products:', Object.keys(ownedProducts));
    rules.forEach(function (rule) {
      const lines = Object.keys(rule.map).map(function (variantId) {
        const trigger = rule.main.variants.filter(function (v) { return String(v.id) === variantId; })[0];
        return '    ' + (trigger ? trigger.title : variantId) + ' => ' + rule.map[variantId].map(function (g) {
          return g.variant.title + (g.qty > 1 ? ' x' + g.qty : '') + (g.variant.available ? '' : ' (sold out)');
        }).join(', ');
      });
      console.log('[bl-free-gift] rule ' + rule.index + ':', rule.active && cfg.enabled ? 'ACTIVE' : 'inactive',
        '|', rule.main ? rule.main.title : '(no trigger product)', '→', rule.gift ? rule.gift.title : '(no gift product)',
        '|', rule.eligibility, '|', rule.soldOut, '\n' + (lines.join('\n') || '    (no mapping lines resolved)'));
    });
    const p = plan(cart);
    console.log('[bl-free-gift] current cart → needed:', p.needed, '| in cart:', p.current, '| updates to post:', p.updates || 'none (in sync)', '| stuck:', stuck);
    return p;
  };
})();

/********************************
 * Lenis – let drawers scroll natively, pause page scroll while one is open
 ********************************/
(function () {
  // data-lenis-prevent tells Lenis to bail out of wheel events whose target
  // sits inside this element, so the drawer body's overflow-y: auto can do
  // its native scroll. lenis.stop() alone isn't enough — Lenis still
  // preventDefault()s wheel events even when stopped.
  function markDrawersForLenis() {
    document.querySelectorAll('.drawer').forEach(function (drawer) {
      if (!drawer.hasAttribute('data-lenis-prevent')) {
        drawer.setAttribute('data-lenis-prevent', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDrawersForLenis);
  } else {
    markDrawersForLenis();
  }

  // Pause Lenis page scroll while any drawer is open.
  var openDrawerCount = 0;

  document.addEventListener('toggle', function (e) {
    if (!e.target.classList || !e.target.classList.contains('drawer')) return;
    if (!window.lenis) return;

    if (e.target.hasAttribute('open')) {
      openDrawerCount++;
      if (openDrawerCount === 1) window.lenis.stop();
    } else {
      openDrawerCount = Math.max(0, openDrawerCount - 1);
      if (openDrawerCount === 0) window.lenis.start();
    }
  });
})();
/********************************
 * Add-to-cart label by purchase option
 ********************************/
// <buy-buttons data-atc-label-onetime="…" data-atc-label-subscription="…"> (rendered by
// snippets/buy-buttons.liquid and the product page sticky bar) carries both labels for the
// current variant; product-rerender swaps the element on variant change, so the labels stay
// current. This picks the one matching the purchase option currently selected:
//  - Product page: the Recharge widget (<recharge-subscription-widget>, shadow DOM). Its
//    "purchaseOption" radio group is the source of truth, read the same way the welcome-kit
//    code in layout/theme.liquid does. The widget raises no DOM event outside its shadow root,
//    so its radios are bound directly once rendered and the page is also polled at a low rate
//    to catch async renders and Lit re-renders.
//  - Product Tabs V2: bl-selling-plan-picker writes the `selling_plan` field on the form and
//    fires `selling-plan:change`.
// Console helper: blAtcLabels.debug() dumps what the script sees for every labelled button.
(function () {
  const SELECTOR = 'buy-buttons[data-atc-label-onetime]';
  const OPTION_INPUTS = 'input[name="purchaseOption"], input.rc-purchase-option__input, [part~="rc-purchase-option__input"]';
  const POLL_MS = 300;
  let reported = false;

  // The widget nests components (e.g. <rc-selling-plans>) with their own shadow roots.
  function shadowRoots(root, out = []) {
    if (!root) return out;
    out.push(root);
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) shadowRoots(el.shadowRoot, out);
    });
    return out;
  }

  // The product form holds a hidden variant input named "id", and named form controls shadow
  // built-in form properties, so `form.id` is that input, not the id string (theme.js relies on
  // this with `this.id.value`). Always read the attribute.
  function formId(form) {
    return form.getAttribute('id');
  }

  // The Recharge app block renders in the same section as the product form it belongs to.
  function widgetFor(form) {
    const rerender = document.querySelector(`product-rerender[observe-form="${formId(form)}"]`);
    const scope = (rerender || form).closest('.shopify-section');
    return scope ? scope.querySelector('recharge-subscription-widget') : null;
  }

  // Input value plus every ancestor class inside the shadow root, for markup that only tells
  // one-time from subscription on a wrapper (rc-selection__onetime, rc-purchase-option__subscription).
  function hintFor(input) {
    const parts = [input.value, input.className];
    for (let el = input.parentElement; el; el = el.parentElement) parts.push(el.className || '');
    return parts.join(' ');
  }

  // 'subscription' | 'onetime' | null while the widget has not rendered its options yet.
  function widgetSelection(widget) {
    for (const root of shadowRoots(widget.shadowRoot)) {
      // Same rule as the welcome kit: the "subscription" radio's checked state is the selection.
      const subscription = root.querySelector('input[name="purchaseOption"][value="subscription"]');
      if (subscription) return subscription.checked ? 'subscription' : 'onetime';

      for (const input of root.querySelectorAll(OPTION_INPUTS)) {
        if (!input.checked) continue;
        const hint = hintFor(input);
        if (/subscription/i.test(hint)) return 'subscription';
        if (/onetime|one-time|one_time/i.test(hint)) return 'onetime';
      }
    }
    return null;
  }

  function bindWidget(widget) {
    for (const root of shadowRoots(widget.shadowRoot)) {
      root.querySelectorAll(OPTION_INPUTS).forEach((input) => {
        if (input._blAtcBound) return;
        input._blAtcBound = true;
        input.addEventListener('change', applyAll);
      });
    }
  }

  function sellingPlanFields(form) {
    const field = form.elements['selling_plan'];
    if (!field) return [];
    return field instanceof RadioNodeList ? Array.from(field) : [field];
  }

  // true / false when the page tells us, null when it does not (the server label stays).
  function subscriptionSelected(form) {
    const widget = widgetFor(form);
    if (widget) {
      bindWidget(widget);
      const selection = widgetSelection(widget);
      if (selection) return selection === 'subscription';
    }

    const fields = sellingPlanFields(form);
    if (fields.length) return fields.some((el) => !el.disabled && el.value !== '');

    return null;
  }

  // <button is="custom-button"> moves its label into a child <div> and appends a loader span;
  // write into that div so the loading animation keeps working.
  function labelTarget(button) {
    return button._contentElement || Array.from(button.children).find((el) => el.tagName === 'DIV') || button;
  }

  function applyLabels(form) {
    const id = form ? formId(form) : null;
    if (!id) return;

    const selected = subscriptionSelected(form);
    if (selected === null) return;

    document.querySelectorAll(`${SELECTOR}[form="${id}"]`).forEach((buyButtons) => {
      const label = selected ? buyButtons.dataset.atcLabelSubscription : buyButtons.dataset.atcLabelOnetime;
      const button = buyButtons.querySelector('button[type="submit"]');

      // Sold out / unavailable buttons are disabled and keep their state label.
      if (!label || !button || button.disabled) return;

      const target = labelTarget(button);
      // The diaper bundle / purchase cards (snippets/variant-picker-diaper-cards.liquid, bl-purchase-cards-diaper.liquid)
      // append the selected card's price as <span class="bl-atc-price"> inside the label; compare and rewrite the text
      // without touching that span.
      const priceEl = target.querySelector('.bl-atc-price');
      const current = priceEl ? target.textContent.replace(priceEl.textContent, '').trim() : target.textContent.trim();
      if (current !== label) {
        target.textContent = label;
        if (priceEl) target.append(priceEl);
      }
    });
  }

  function applyAll() {
    try {
      const forms = new Set();
      document.querySelectorAll(SELECTOR).forEach((el) => {
        const form = document.forms[el.getAttribute('form')];
        if (form) forms.add(form);
      });
      forms.forEach(applyLabels);
    } catch (error) {
      if (!reported) console.warn('[bl-atc-labels]', error);
      reported = true;
    }
  }

  function formFrom(event) {
    const target = event.target;
    if (target instanceof HTMLFormElement) return target;
    return target?.form || target?.closest?.('form') || null;
  }

  // Product Tabs V2 picker, and any light-DOM selling plan control.
  document.addEventListener('selling-plan:change', (event) => applyLabels(formFrom(event)));
  document.addEventListener('change', (event) => {
    if (event.target?.name === 'selling_plan') applyLabels(formFrom(event));
  }, true);

  // Variant change: product-rerender has just replaced <buy-buttons> with the server version,
  // which only knows the preselected state.
  document.addEventListener('variant:change', (event) => applyLabels(formFrom(event)));

  // Low-rate poll for the Recharge widget: async first render, Lit re-renders (new radios to
  // bind) and programmatic `selling_plan` updates raise no event we can hook.
  setInterval(() => {
    if (document.visibilityState === 'visible' && document.querySelector(SELECTOR)) applyAll();
  }, POLL_MS);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  window.blAtcLabels = {
    apply: applyAll,
    debug() {
      return Array.from(document.querySelectorAll(SELECTOR)).map((el) => {
        const form = document.forms[el.getAttribute('form')];
        const widget = form ? widgetFor(form) : null;
        const inputs = widget ? shadowRoots(widget.shadowRoot).flatMap((root) => Array.from(root.querySelectorAll('input'))) : [];
        return {
          form: el.getAttribute('form'),
          formFound: !!form,
          widgetFound: !!widget,
          widgetShadowRoot: !!(widget && widget.shadowRoot),
          widgetInputs: inputs.map((i) => `${i.type} name=${i.name} value=${i.value} checked=${i.checked} class=${i.className}`),
          widgetSelection: widget ? widgetSelection(widget) : null,
          sellingPlanFields: form ? sellingPlanFields(form).map((f) => `value=${f.value} disabled=${f.disabled}`) : [],
          selected: form ? subscriptionSelected(form) : null,
          labels: { onetime: el.dataset.atcLabelOnetime, subscription: el.dataset.atcLabelSubscription },
          buttonText: el.querySelector('button[type="submit"]')?.textContent.trim() || null
        };
      });
    }
  };
})();
